import React from "react";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { PublicHeader } from "@/components/PublicHeader";
import { PRO_LEGAL_LINE } from "@/theme";
import { useI18n } from "@/i18n";

// En-tête du parcours prospect : marque blanche du pro si présente, sinon Déco Ligot.
export function ProspectHeader({ pro }) {
  if (!pro) return <PublicHeader />;
  return (
    <header className="sticky top-0 z-40 border-b border-line bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-5 py-3">
        <div className="flex min-w-0 items-center gap-3">
          {pro.logo_url ? (
            <img data-testid="pro-logo" src={pro.logo_url} alt={pro.company_name || ""} className="h-10 max-w-[150px] object-contain" />
          ) : null}
          <span data-testid="pro-company-name" className="truncate text-[16px] font-semibold text-ink">{pro.company_name}</span>
        </div>
        <LanguageSwitcher />
      </div>
    </header>
  );
}

// Liens CGV / RGPD du pro (quand renseignés). Réutilisable (pied de page + consentement).
export function LegalLinks({ pro, className = "", align = "center" }) {
  const { t } = useI18n();
  if (!pro || (!pro.cgv_url && !pro.gdpr_url)) return null;
  return (
    <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""} ${className}`}>
      {pro.cgv_url ? (
        <a data-testid="legal-cgv" href={pro.cgv_url} target="_blank" rel="noreferrer" className="text-[12px] font-medium text-brand underline">{t("legal_cgv")}</a>
      ) : null}
      {pro.gdpr_url ? (
        <a data-testid="legal-gdpr" href={pro.gdpr_url} target="_blank" rel="noreferrer" className="text-[12px] font-medium text-brand underline">{t("legal_gdpr")}</a>
      ) : null}
    </div>
  );
}

// Pied de page du parcours prospect : mention légale + liens CGV / RGPD.
export function ProFooter({ pro, className = "" }) {
  const { t } = useI18n();
  const line = pro?.company_name ? `${pro.company_name} — ${t("pro_resp_line")}` : PRO_LEGAL_LINE;
  return (
    <div className={className}>
      <p data-testid="pro-legal-line" className="mx-auto max-w-6xl text-center text-[12px] leading-relaxed text-mute">{line}</p>
      <LegalLinks pro={pro} className="mt-1.5" />
    </div>
  );
}
